import SoftBadge from "modules/common/SoftBadge";
import FeedbackForm from "modules/dashboards/feedback_form/FeedbackForm";
import { getFormattedDate } from "modules/utilities/utility";
import React from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

function Table({ data, handleCall, callIcons }) {
  return (
    <div className="shadow rounded-bottom rounded-2 text-black">
      <div
        style={{ background: "#F9FAFD" }}
        className="d-flex p-3 rounded-top fw-bold"
      >
        <span style={{ flex: 1.5 }}>Reminder date</span>
        <span style={{ flex: 1 }}>Name</span>
        <div style={{ flex: 1.5 }}>Tag</div>
        <div
          style={{ flex: 0.5 }}
          className="d-flex justify-content-evenly align-items-center"
        >
          Action
        </div>
      </div>
      {data.map((row, index) => {
        return (
          <div
            className={`d-flex p-3 ${
              index === data.length - 1 && `rounded-2 rounded-bottom`
            }`}
          >
            <span style={{ flex: 1.5 }}>
              {getFormattedDate(row.reminder_date)}
            </span>
            <span style={{ flex: 1 }}>
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    <div className="fw-bold">Lead Detail </div>
                  </Tooltip>
                }
              >
                <Link
                  to={`/lead-details/${row.case.id}`}
                  className="text-primary fw-bold"
                >
                  {row.case.user.first_name}
                </Link>
              </OverlayTrigger>
            </span>
            <div style={{ flex: 1.5 }}>
              <SoftBadge bg="primary">{row.tag}</SoftBadge>
              <span>{row.case.latest_order_count}</span>
            </div>
            <div
              style={{ flex: 0.5 }}
              className="d-flex justify-content-evenly align-items-center"
            >
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    <span className="fw-bold">Call</span>
                  </Tooltip>
                }
              >
                <div
                  onClick={() =>
                    handleCall(row.case.id, row._id, row.case.user.phone_number)
                  }
                >
                  {callIcons[row.case.id]}
                </div>
              </OverlayTrigger>
              <FeedbackForm
                week={row.tag}
                id={row._id}
                bookingId={row.booking_reference_id}
                list={true}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Table;
